import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Flex,
    IconPhoneCircle,
    IconMail,
    Spacer,
    Text,
    TextButton,
} from '@zillow/constellation';

import numberUtils from 'app/shared/utils/numberUtils';

import {
    StyledContainer,
    StyledIconContainer,
    StyledGrayText,
    StyledDesktopStatusText,
    StyledMobileStatusText,
    StyledSuccessIcon,
} from './StyledComponents';

const propTypes = {
    data: PropTypes.shape({
        isVerified: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired,
    }).isRequired,
    emailVerificationText: PropTypes.string,
    inManageContactModal: PropTypes.bool,
    onDelete: PropTypes.func, // eslint-disable-line react/require-default-props
    onVerifyPhoneClick: PropTypes.func, // eslint-disable-line react/require-default-props
    onVerifyEmailClick: PropTypes.func, // eslint-disable-line react/require-default-props
};

const defaultProps = {
    emailVerificationText: 'Send verification email',
    inManageContactModal: false,
};

const ContactMethodDetail = ({
    data: { isVerified, value },
    emailVerificationText,
    inManageContactModal,
    onDelete,
    onVerifyPhoneClick,
    onVerifyEmailClick,
}) => {
    const isEmail = isNaN(parseInt(value, 10));
    const Icon = isEmail ? IconMail : IconPhoneCircle;
    const statusText = isVerified ? (
        <>
            <StyledSuccessIcon />
            Verified
        </>
    ) : 'Pending';

    const getHelpText = () => {
        let textToRender = '';
        if (inManageContactModal && isVerified) {
            textToRender = 'A verified contact cannot be removed';
        } else if (!inManageContactModal && !isVerified) {
            textToRender = `Start ${isEmail ? 'email' : 'phone'} verification here`;
        }

        return textToRender;
    };

    const getCTAButton = () => {
        if (inManageContactModal) {
            return <TextButton onClick={() => onDelete({ isVerified, value })}>Remove</TextButton>;
        }
        return (
            <Button
                buttonType="primary"
                onClick={() => (isEmail ? onVerifyEmailClick(value) : onVerifyPhoneClick(value))}
            >
                {isEmail ? emailVerificationText : 'Verify now'}
            </Button>
        );
    };

    return (
        <StyledContainer className="ContactMethodDetail">
            <StyledIconContainer>
                <Icon fontColor="brand" size="md" />
            </StyledIconContainer>
            <Flex display="flex" flexDirection="column" flexGrow={1}>
                <Text as="div">
                    <b>{isEmail ? value : numberUtils.formatPhoneNumberInput(value)}</b>
                </Text>
                <StyledGrayText as="div">{getHelpText()}</StyledGrayText>
                <StyledMobileStatusText>{statusText}</StyledMobileStatusText>
                {!isVerified && (
                    <Spacer marginTop="xs">
                        {getCTAButton()}
                    </Spacer>
                )}
            </Flex>
            <StyledDesktopStatusText>
                {statusText}
            </StyledDesktopStatusText>
        </StyledContainer>
    );
};

ContactMethodDetail.propTypes = propTypes;
ContactMethodDetail.defaultProps = defaultProps;

export default ContactMethodDetail;
